import { useQuery } from "@tanstack/react-query";
import { useAtomValue } from "jotai";
import api from "../../utils/api";
import { userAtom } from "../../utils/store";

interface UseGetSpecializationByProgramIdQueryProps {
  programId?: number;
}

const getSpecializationByProgramId = async (programId: number) => {
  return (
    await api.get(`/Concentration/ByProgram/${programId}`, {
      skipAuthRedirect: true,
    } as any)
  ).data as SpecializationByProgramResponse;
};

export const useGetSpecializationByProgramIdQuery = (
  props?: UseGetSpecializationByProgramIdQueryProps,
) => {
  const user = useAtomValue(userAtom);
  const programId = props?.programId ?? user?.programId;

  const query = useQuery({
    queryKey: ["get-specialization-by-program-id", programId],
    queryFn: () => getSpecializationByProgramId(programId as number),
    enabled: !!programId,
  });

  return {
    ...query,
    specializations: query.data?.data as SpecializationByProgram[] | undefined,
    concentrations: query.data?.data as SpecializationByProgram[] | undefined,
  };
};

export default useGetSpecializationByProgramIdQuery;
